<template>
  <div
    class="layout"
    :class="[computedCharacterColorClass]"
  >
    <!-- 梵字・家紋 + 俗名の表記（ラベル） + 俗名 -->
    <div
      class="main"
      :class="{
        adjust: isBackSymbolAvailable,
      }"
    >
      <!-- 梵字・家紋 -->
      <div>
        <div
          v-if="isBackSymbolAvailable"
          class="symbol flex center"
        >
          <div class="box">
            <ImageResolver
              :src="computedBackSymbolSrc"
              class="character"
            />
          </div>
        </div>
      </div>

      <!-- 俗名の表記（ラベル） -->
      <div
        class="secularNamePrefixes"
        :class="{
          adjust: secularNamePrefix.length,
        }"
      >
        <div class="secularNamePrefix flex center column">
          <!-- 俗名の表記（ラベル） -->
          <TabletCharacterImage
            v-for="(character, index) in secularNamePrefix"
            :key="`secularNamePrefix-${character}-${index}`"
            :char="character"
            :font="typography.font"
            :size="computedCharacterSize"
            @onClickCharacter="onClickCharacter({
              ...secularNamePrefixPayload,
              characterIndex: index,
              columnIndex: null,
              ...$event,
            })"
          />
        </div>
      </div>

      <!-- 俗名 -->
      <div class="secularNames">
        <div
          v-for="(column, columnIndex) in columns"
          :key="`secularName-${column.order}`"
          class="secularName flex center column"
        >
          <!-- 俗名 -->
          <TabletCharacterImage
            v-for="(character, index) in column.secularName"
            :key="`secularName-${character}-${index}`"
            :char="character"
            :font="typography.font"
            :size="computedCharacterSize"
            @onClickCharacter="onClickCharacter({
              ...secularNamePayload,
              characterIndex: index,
              columnIndex: columnIndex,
              ...$event,
            })"
          />
        </div>
      </div>

      <!-- スペーサー -->
      <div />
    </div>

    <!-- 左側: 享年表記 + 没年齢 + 没年齢単位 -->
    <!-- 右側: 没年月日 + 没表記 -->
    <div class="side">
      <div class="dates">
        <!-- 左側: 享年表記 + 没年齢 + 没年齢単位 -->
        <div class="date left flex align-center column">
          <div class="box grow" />
          <div class="box flex column">
            <!-- 左側: 享年表記 -->
            <TabletCharacterImage
              v-for="(character, index) in columns[0].ageAtDeathPrefix"
              :key="`ageAtDeathPrefix-${character.character}-${index}`"
              :char="character"
              :font="typography.font"
              :size="computedSideLeftCharacterSize"
              @onClickCharacter="onClickCharacter({
                ...ageAtDeathPrefixPayload,
                characterIndex: index,
                columnIndex: 0,
                ...$event,
              })"
            />

            <!-- 左側: 没年齢 -->
            <TabletCharacterImage
              v-for="(character, index) in columns[0].ageAtDeath"
              :key="`ageAtDeath-${character.character}-${index}`"
              :char="character"
              :font="typography.font"
              :size="computedSideLeftCharacterSize"
              @onClickCharacter="onClickCharacter({
                ...ageAtDeathPayload,
                characterIndex: index,
                columnIndex: 0,
                ...$event,
              })"
            />

            <!-- 左側: 没年齢単位 -->
            <TabletCharacterImage
              v-for="(character, index) in columns[0].ageUnitCharacter"
              :key="`ageUnitCharacter-${character.character}-${index}`"
              :char="character"
              :font="typography.font"
              :size="computedSideLeftCharacterSize"
              @onClickCharacter="onClickCharacter({
                ...ageUnitCharacterPayload,
                characterIndex: index,
                columnIndex: 0,
                ...$event
              })"
            />
          </div>
        </div>

        <!-- 右側: 没年月日 + 没表記 -->
        <div class="date right flex align-center column">
          <div class="box grow" />
          <div class="box flex column">
            <!-- 右側: 没年 -->
            <TabletCharacterImage
              v-for="(character, index) in columns[0].dateOfDeathYear"
              :key="`deathYear-${character.character}-${index}`"
              :char="character"
              :font="typography.font"
              :size="computedSideRightCharacterSize"
              @onClickCharacter="onClickCharacter({
                ...dateOfDeathYearPayload,
                characterIndex: index,
                columnIndex: 0,
                ...$event,
              })"
            />

            <!-- 右側: 没月 -->
            <TabletCharacterImage
              v-for="(character, index) in columns[0].dateOfDeathMonth"
              :key="`deathMonth-${character.character}-${index}`"
              :char="character"
              :font="typography.font"
              :size="computedSideRightCharacterSize"
              @onClickCharacter="onClickCharacter({
                ...dateOfDeathMonthPayload,
                characterIndex: index,
                columnIndex: 0,
                ...$event,
              })"
            />

            <!-- 右側: 没日 -->
            <TabletCharacterImage
              v-for="(character, index) in columns[0].dateOfDeathDay"
              :key="`deathDay-${character.character}-${index}`"
              :char="character"
              :font="typography.font"
              :size="computedSideRightCharacterSize"
              @onClickCharacter="onClickCharacter({
                ...dateOfDeathDayPayload,
                characterIndex: index,
                columnIndex: 0,
                ...$event,
              })"
            />

            <!-- 右側: 没表記 -->
            <TabletCharacterImage
              v-for="(character, index) in diedCharacter"
              :key="`diedCharacter-${character.character}-${index}`"
              :char="character"
              :font="typography.font"
              :size="computedSideRightCharacterSize"
              @onClickCharacter="onClickCharacter({
                ...diedCharacterPayload,
                characterIndex: index,
                columnIndex: null,
                ...$event,
              })"
            />
          </div>
          <div class="box grow" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TabletPreviewMixin from "@/mixins/tabletPreview.mixin";

export default {
  mixins: [
    TabletPreviewMixin.back,
    TabletPreviewMixin.character,
  ],
  data () {
    return {
    };
  },
  computed: {
    // 俗名の表記（ラベル）+ 俗名
    // の文字列の長さから要素一つあたりのサイズを算出
    computedCharacterSize () {
      const {
        columns,
        secularNamePrefix,
      } = this;

      const defaultSize = 25;
      const gap = secularNamePrefix.length ? 15 : 0;
      const maxHeight = 320 - 15 - gap;
      const characterLength = columns[0].secularName.length + secularNamePrefix.length;
      const characterSize = maxHeight / characterLength;
      const size = Math.min(defaultSize, characterSize);

      return size;
    },

    // 享年表記 + 没年齢 + 没年齢単位
    // の文字列の長さから要素一つあたりのサイズを算出
    computedSideLeftCharacterSize () {
      const {
        ageAtDeathPrefix,
        ageAtDeath,
        ageUnitCharacter,
      } = this.columns[0];

      const defaultSize = 20;
      const maxHeight = 400 - 15 - 15; // padding の上下分

      const ageAtDeathPrefixLength = ageAtDeathPrefix ? ageAtDeathPrefix.length : 0;
      const ageUnitCharacterLength = ageUnitCharacter ? ageUnitCharacter.length : 0;
      const characterLength = ageAtDeathPrefixLength + ageAtDeath.length + ageUnitCharacterLength;
      const characterSize = maxHeight / characterLength;
      const size = Math.min(defaultSize, characterSize);

      return size;
    },

    // 没年, 没月, 没日, 没表記
    // の文字列の長さから要素一つあたりのサイズを算出
    computedSideRightCharacterSize () {
      const { diedCharacter } = this;
      const {
        dateOfDeathYear,
        dateOfDeathMonth,
        dateOfDeathDay,
      } = this.columns[0];

      const defaultSize = 20;
      const maxHeight = 400 - 15 - 15; // .right の padding の上下分
      const characterLength = dateOfDeathYear.length + dateOfDeathMonth.length + dateOfDeathDay.length + diedCharacter.length;
      const characterSize = maxHeight / characterLength;
      const size = Math.min(defaultSize, characterSize);

      return size;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
@import "~@/assets/styles/tablet-back.scss";

.layout {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;

  .main {
    display: grid;
    grid-template-rows: 80px auto auto 1fr;
    grid-template-columns: 1fr;
    height: 100%;
    width: 50px;
    position: absolute;
    top: 0;
    left: -50px;
    box-sizing: border-box;
    overflow-x: visible;
    z-index: 1;

    &.adjust {
      padding-bottom: 15px; // (80 - 50) / 2
    }

    @include symbol(100px); // (150 + 50) / 2

    .secularNamePrefixes,
    .secularNames {
      height: 100%;
      width: 100%;
      position: relative;
      box-sizing: border-box;

      .secularNamePrefix,
      .secularName {
        height: 100%;
        transform: translateX(100px);

        @include character(25px);
      }
    }

    .secularNamePrefixes {
      padding-top: 15px;

      &.adjust {
        padding-bottom: 15px;
      }
    }
  }

  .side {
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr;
    height: 100%;
    position: relative;
    box-sizing: border-box;

    .dates {
      height: 100%;
      width: 100%;
      position: relative;

      .date {
        height: 100%;
        width: 50px;
        padding: 15px 0;
        box-sizing: border-box;

        &.left {
          float: left;
        }

        &.right {
          float: right;
          transform: translateX(0px);
        }

        @include character(20px);
      }
    }
  }
}
</style>
